module.exports = __webpack_public_path__ + "img/suport-v2.fca5b7e7.png";